import { TCol } from "../../components/layout/listing-table/listing-table.types";
import {
  Date,
  StatusChip,
} from "../../components/layout/listing-table/listing-table-render-components";
import {
  renderAvatarList,
  renderAvatarListFromContentCreators,
} from "../../components/layout/listing-table/listing-table-render-components/avatar-list/avatar-list.functions";

export const workOrderListingColumns: TCol[] = [
  { label: "Creative due date", key: "due_at", render: (row) => Date(row.dueAt, "MMM DD YYYY") },
  { label: "WO #", key: "name" },
  { label: "Status", key: "status", render: (row) => StatusChip(row.status) },
  { label: "Owner", key: "ownerName" },
  { label: "Template", key: "template" },
  {
    label: "Assignees",
    key: "contentCreators",
    render: (row) => renderAvatarListFromContentCreators(row.contentCreators, "Unassigned"),
  },
  { label: "Multi Channel Brief", key: "executionBriefName" },
  { label: "Approvers", key: "reviewers", render: (row) => renderAvatarList(row.reviewers) },
];
